import { useState } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useUrlFilterState } from "../../hooks/useUrlFilterState";
// State Import
import { useCompletedReturnOrderList } from "../../state/completedReturnOrderListState";
// Component imports
import { GenericListHeader } from "../../components/GenericHeader";
import { ReturnTableFilterBar } from "./CompletedReturnTableFilterBar";
import { ReturnTable } from "./CompletedReturnTable";

export function ReturnOrderCompletedList() {
  const [returns, setReturns] = useState({
    completedOrder: [],
    filter: {},
    paging: {},
  });

  const [returnsFilter, setReturnsFilter] = useUrlFilterState(
    {
      branchFilter: "Mine",
      myBranchesFilter: "All",
      search: "",
      page: 1,
      pageSize: 25,
    },
    { exclude: ["pageSize"] },
  );

  const { isPending, isError, isSuccess, data, error, isFetching } =
    useCompletedReturnOrderList(returnsFilter);

  // Success Function
  const successFunc = () => setReturns(data.data.data.data.list);
  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      <GenericListHeader heading={"Returns Completed"} />
      <ReturnTableFilterBar
        returnsFilter={returnsFilter}
        setReturnsFilter={setReturnsFilter}
      />
      {isError && <span>Error: {error.message}</span>}
      {returns && returns.length !== 0 ? (
        <ReturnTable
          data={returns}
          loading={isFetching}
          returnsFilter={returnsFilter}
          setReturnsFilter={setReturnsFilter}
        />
      ) : (
        !isPending && <p>No results</p>
      )}
    </>
  );
}
